import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage,sendpostnow } from './Dynamictable';
import Usersession from './Usersession';
export default class Viewposts extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
        name: "SIIKAA",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c'}],	
       
       tblfiterdata: [{pcode:'000', poststartdate:'2025-05-01', expry:'2025-05-01'}]
 	
    };

    
   
    
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
	
        const pid = localStorage.getItem("id");
        
        this.setserverurl();
        const ar = [{id:1, nm: 'c'},{id:2, nm: 'd'}]
	
	const cols = ["Code","Poststart","Postend"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
        const code = localStorage.getItem("id"); 
        this.getpostdata(code);

    }
 
 getpostdata(eid: any){
	 try {
          const url = "/getpostsbyuid?prd='" + eid +"'";
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
             
		this.reducearray(tdata);
            })
            .catch((err: any) => {
                alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
	else{
	farr.shift();
	getmessage('You have no posts','');
	}
	this.setState({ tblfiterdata: farr});
	
      }	

 gotopostproperty(e:any){
   const codewithexp = e.target.id;
    const code = codewithexp.split(',')[0];
    Usersession.setPostexpdays("0");
    if(codewithexp.split(',')[1].length > 0){
	const expdt = codewithexp.split(',')[1];
	const cdate = new Date();
	const expdate = new Date(expdt);
         if(expdate && cdate){
	 const expinmili = expdate.getTime();
	const curinmili = cdate.getTime();
	if(expinmili > curinmili){
	 let timeDifference = expinmili - curinmili;
	const millisecondsInADay = 1000 * 60 * 60 * 24;

  	const diffInDays = Math.floor(timeDifference / millisecondsInADay);

  	 if(diffInDays > 0){
	  	const difd = "" + diffInDays;
		Usersession.setPostexpdays(difd);
	  	//alert(difd);
	 	} 
	
	   }	
	}
     }
   
  
   //Usersession.setProcode(code);
   const ofid = localStorage.getItem("offerid");
   sendpostnow(code,ofid);	
   e.preventDefault()
 }   
 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			{this.state.tblheaders.map((str,index)=>(
			<th className="comptd" style={{width:'30%'}}>{str}</th>
			))}
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
		<tr>
			<td className="comptd" style={{width:'30%'}}>
			  <a href="#" onClick={e => this.gotopostproperty(e)} >
				<span id={row.pcode+","+row.expry}>{row.pcode}</span>
			   </a>
			</td>
			<td className="comptd" style={{width:'30%'}}><span>{row.poststartdate}</span></td>
			<td className="comptd" style={{width:'30%'}}><span>{row.expry}</span></td>
		</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

